export function getChecklistLandingPath(
  checklistId: string | number,
  unitCount: number,
  filterValues?: Record<string, unknown>
) {
  const encodedChecklistId = encodeURIComponent(String(checklistId));
  const path =
    unitCount === 1
      ? `/checklists/${encodedChecklistId}/details`
      : `/checklists/${encodedChecklistId}`;
  const filter: Record<string, unknown> = {};

  appendFilterValue(filter, 'from', filterValues?.from);
  appendFilterValue(filter, 'to', filterValues?.to);

  return Object.keys(filter).length === 0
    ? path
    : `${path}?${new URLSearchParams({ filter: JSON.stringify(filter) }).toString()}`;
}

export function getChecklistDetailsPath(
  checklistId: string | number,
  unitId: string | number,
  filterValues: Record<string, unknown>
) {
  const filter: Record<string, unknown> = {
    unitId: [unitId],
  };

  appendFilterValue(filter, 'from', filterValues.from);
  appendFilterValue(filter, 'to', filterValues.to);

  const params = new URLSearchParams({ filter: JSON.stringify(filter) });

  return `/checklists/${encodeURIComponent(String(checklistId))}/details?${params.toString()}`;
}

export function getChecklistDetailsUrlFilters(searchParams: URLSearchParams) {
  const filter = parseFilter(searchParams.get('filter'));
  const from = getStringValue(filter?.from) ?? searchParams.get('from');
  const to = getStringValue(filter?.to) ?? searchParams.get('to');
  const filterUnitId = Array.isArray(filter?.unitId)
    ? filter.unitId[0]
    : filter?.unitId;
  const unitId = parseUnitId(
    filterUnitId === undefined
      ? searchParams.get('unitId')
      : String(filterUnitId)
  );

  return {
    period: from && to ? { from, to } : undefined,
    unitId,
  };
}

function appendFilterValue(
  filter: Record<string, unknown>,
  name: string,
  value: unknown
) {
  if (typeof value === 'string' && value.length > 0) {
    filter[name] = value;
  }
}

function parseFilter(value: string | null) {
  if (value === null) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(value);
    return isRecord(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function getStringValue(value: unknown) {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

function parseUnitId(value: string | null) {
  if (value === null || value.length === 0) {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}
